import { render } from "./CertificateGeneratorDownloadsBulk.vue?vue&type=template&id=069c2a4b"
import script from "./CertificateGeneratorDownloadsBulk.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorDownloadsBulk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__